import { render, staticRenderFns } from "./MediacontactPartnerForm.vue?vue&type=template&id=0b888f08"
import script from "./MediacontactPartnerForm.vue?vue&type=script&lang=js"
export * from "./MediacontactPartnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports